import './DepositButton.css';
import React from 'react';
import classNames from 'classnames';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { useDispatch, useSelector } from 'react-redux';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useLowBalanceState } from './hooks/use-low-balance-state.hook';

export const DepositButton = ({
    withIcon = false,
}) => {
    const { t } = useTranslations();
    const dispatch = useDispatch();
    const { showDeposit } = useAsgActions();
    const { balance } = useSelector((state) => state.player);
    const { isLowAmount } = useLowBalanceState(balance);

    const classes = classNames(
        'game-page-header-deposit',
        {
            'game-page-header-item-hoverable': !isLowAmount,
            'game-page-header-deposit--low-balance': isLowAmount,
            'game-page-header-deposit--with-icon': withIcon,
        }
    );

    return (
        <div
            className={classes}
            onClick={() => dispatch(showDeposit())}
        >
            {withIcon && <div className="game-page-header-deposit__icon" />}
            <div className="game-page-header-deposit__text">{t('deposit')}</div>
        </div>
    );
};
